var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReduceReturns(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 480,
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 180,
    r: 180,
    fill: "#dfdede",
    fillOpacity: 0.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a58450",
    d: "M 134.214844 136.492188 L 216.164062 101.359375 L 182.230469 87.421875 C 180.800781 86.832031 179.191406 86.832031 177.757812 87.421875 L 96.261719 120.902344 Z M 134.214844 136.492188 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a58450",
    d: "M 231.414062 107.625 L 149.441406 142.75 L 179.996094 155.300781 L 263.730469 120.902344 Z M 231.414062 107.625 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a58450",
    d: "M 174.109375 165.609375 L 140.949219 151.984375 L 140.949219 177.777344 C 140.949219 181.03125 138.3125 183.664062 135.0625 183.664062 C 131.8125 183.664062 129.175781 181.03125 129.175781 177.777344 L 129.175781 147.148438 L 90.976562 131.457031 L 90.976562 235.070312 C 90.976562 237.457031 92.417969 239.609375 94.628906 240.515625 L 174.109375 273.167969 Z M 174.109375 165.609375 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a58450",
    d: "M 185.882812 165.609375 L 185.882812 273.167969 L 265.363281 240.515625 C 267.570312 239.609375 269.011719 237.457031 269.011719 235.070312 L 269.011719 131.457031 Z M 185.882812 165.609375 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceReturns);
export default __webpack_public_path__ + "static/media/reduce-returns.c79f2beab2830bd271c6d22e394da869.svg";
export { ForwardRef as ReactComponent };